import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { INVOICE_SEARCH_SERVICE_URL } from 'src/app/injection-tokens';
import { Observable } from 'rxjs';
import { SearchResult } from './search-result';

@Injectable({
  providedIn: 'root',
})
export class InvoiceSearchService {
  constructor(
    @Inject(INVOICE_SEARCH_SERVICE_URL) readonly serviceURL: string,
    readonly http: HttpClient
  ) {}

  getInvoiceSearchResults(invoiceId: string, getInvoices: boolean): Observable<SearchResult[]> {
    return this.http.get<SearchResult[]>(
      (getInvoices ? `${this.serviceURL}?orderNumber=` : `${this.serviceURL}?invoiceNumber=`) + invoiceId
    );
  }
}
